(function () {
  'use strict';
  if (window.KjsCheckoutTracking) return;
  const storageKey = 'kjs-phase96-checkout-tracking-v1';
  const ttl = 7 * 24 * 60 * 60 * 1000;
  let checking = false, lastCheck = 0;
  async function hash(value) {
    return Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value))), b => b.toString(16).padStart(2, '0')).join('');
  }
  function config() {
    const node = document.querySelector('kjs-delivery-picker [data-config]');
    try { return JSON.parse(node?.textContent || '{}'); } catch (_) { return {}; }
  }
  function enabled() {
    const value = config();
    return value.snapshotCheckout && value.trackCheckout && window.Shopify?.theme?.role === 'unpublished' && Number(window.Shopify?.theme?.id) === 151947575473;
  }
  function read() {
    const entries = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (!Array.isArray(entries)) throw Error('Tracking unavailable');
    return entries.filter(entry => /^[a-f0-9]{64}$/.test(entry.capability || '') && entry.expiresAt > Date.now() && entry.expiresAt <= Date.now() + ttl + 60000).slice(-5);
  }
  function prepare() {
    const entries = read();
    if (entries.length >= 5) throw Error('Review existing checkout attempts before starting another');
    sessionStorage.setItem(storageKey, JSON.stringify(entries));
  }
  async function fingerprint(cart) {
    const sortObject = value => Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b));
    const items = (cart.items || []).map(item => ({key: item.key, variantId: String(item.variant_id), quantity: item.quantity,
      properties: sortObject(item.properties), sellingPlan: item.selling_plan_allocation || null, components: item.item_components || [],
      price: item.final_price, discounts: item.line_level_discount_allocations || []})).sort((a, b) => String(a.key).localeCompare(String(b.key)));
    return hash(JSON.stringify({token: cart.token, items, note: cart.note || '', attributes: sortObject(cart.attributes), discount: cart.total_discount || 0}));
  }
  async function remember(cart, tracking) {
    if (!/^[a-f0-9]{64}$/.test(tracking.capability || '') || !Number.isFinite(tracking.expiresAt) || tracking.expiresAt <= Date.now() || tracking.expiresAt > Date.now() + ttl + 60000) throw Error('Tracking unavailable');
    const entries = read();
    if (entries.length >= 5) throw Error('Too many checkout attempts');
    const lines = cart.items.map(item => ({variantId: String(item.variant_id), quantity: item.quantity})).sort((a, b) => a.variantId.localeCompare(b.variantId));
    entries.push({capability: tracking.capability, expiresAt: tracking.expiresAt, fingerprint: await fingerprint(cart), lines});
    sessionStorage.setItem(storageKey, JSON.stringify(entries));
  }
  async function assess(entry, receipt, cart) {
    if (entry.expiresAt <= Date.now() || receipt.state !== 'completed') return {state: receipt.state === 'review' ? 'review' : 'pending'};
    if (!/^[a-f0-9]{64}$/.test(receipt.receiptId || '') || JSON.stringify(entry.lines) !== JSON.stringify(receipt.lines)) return {state: 'review'};
    if (await fingerprint(cart) !== entry.fingerprint) return {state: 'review', reason: 'basket-changed'};
    const seen = new Set();
    for (const item of cart.items || []) {
      if (!item.key || seen.has(String(item.variant_id)) || Object.keys(item.properties || {}).length || item.selling_plan_allocation || item.item_components?.length) return {state: 'review', reason: 'ambiguous-lines'};
      seen.add(String(item.variant_id));
    }
    return {state: 'verified-unchanged', receiptId: receipt.receiptId};
  }
  async function check() {
    if (!enabled() || checking || Date.now() - lastCheck < 30000 || window.KjsCartControls?.busy || document.querySelector('kjs-delivery-picker[aria-busy="true"]')) return;
    checking = true; lastCheck = Date.now();
    try {
      const entries = read(); if (!entries.length) return;
      const settings = config(), root = (settings.root || '/').replace(/\/?$/, '/');
      const cartResponse = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000)});
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json(); let completed = false;
      for (const entry of entries) {
        const response = await fetch(root + 'apps/kjs-delivery/checkouts/status', {method: 'POST', credentials: 'same-origin', cache: 'no-store', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({capability: entry.capability}), signal: AbortSignal.timeout(12000)});
        if (!response.ok) continue;
        const receipt = await response.json(), result = await assess(entry, receipt, cart);
        if (['verified-unchanged', 'review'].includes(result.state)) completed = true;
      }
      if (completed) document.querySelectorAll('#KjsCartForm, .mfp-wrap .cart_menu form').forEach(form => {
        let notice = form.querySelector('[data-kjs-checkout-review]');
        if (!notice) { notice = document.createElement('p'); notice.setAttribute('data-kjs-checkout-review', ''); notice.setAttribute('role', 'status'); form.prepend(notice); }
        notice.textContent = settings.copy?.checkout_review || '';
      });
    } catch (_) {} finally { checking = false; }
  }
  window.KjsCheckoutTracking = {prepare, remember, assess, fingerprint, check};
  window.addEventListener('pageshow', check);
  window.addEventListener('focus', check);
  if (document.readyState === 'complete') check();
}());
